import { useForm } from "react-hook-form";
import UnForm from "../../../../../Components/Form";
import { ListarTipoPesoAtendimentoAtivosController } from "../../../../../Controllers/Geral/GestaoDeCadastros/TipoPesoAtendimento/TipoPesoAtedimentoControllers";
import { IListarCasoResponse } from "../../../../../Interfaces/Vendas/Caso/CasoInterface";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { VendasListarOrigensLeadController } from "../../../../../Controllers/Vendas/OrigemLead/OrigemLeadController";
import { ListarCanalAtendimentoContoller } from "../../../../../Controllers/Geral/GestaoDeCadastros/TipoCanalAtendimento/TipoCanalAtendimentoController";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { AtualizarAtendimentoController } from "../../../../../Controllers/Geral/Atendimentos/AtendimentosController";
import { ChangeEvent, Dispatch, SetStateAction } from "react";
import OrSpinner from "../../../../../Components/Utils/OrSpinner";
import { MoneyReaisFieldMask } from "../../../../../Validations/InputMasks";
import { formatMoneyReais } from "../../../../../Tools/FormatTools";
import { EditarOportunidadeLeadController } from "../../../../../Controllers/Vendas/Oportunidade/OportunidadeController";
import { IAtualizarAtendimento } from "../../../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import { useModuloInfo } from "../../../../../Context/ModuloInfo";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";

interface IEditarPesoLeads {
    caso: IListarCasoResponse;
    updateList: (...args: any[]) => Promise<IListarCasoResponse[]>;
    setShow: Dispatch<SetStateAction<boolean>>;
}

export default function EditarLead(props: IEditarPesoLeads) {
    const formMethods = useForm();
    const { id } = useModuloInfo();

    const { dadosOportunidade, dadosOportunidadeLoading } =
        useAtendimentoPage();

    function geradorMascaraFinanceira(inputName: keyof IAtualizarAtendimento) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            const mask = MoneyReaisFieldMask(e);
            formMethods.setValue(inputName, mask);
        };
    }

    const { execute: listarCanalAtendimento } = useAsyncCallback(
        () => ListarCanalAtendimentoContoller(),
        []
    );

    const { execute: handleEditar, loading: handleEditarLoading } =
        useAsyncCallback(async (formData: IAtualizarAtendimento) => {
            function finalizarAtualizacao() {
                props.setShow(false);
                props.updateList();
            }

            AtualizarAtendimentoController(props.caso.ID_CASO, {
                ...formData,
                ID_TIPO_PESO_ATENDIMENTO: formData.ID_TIPO_PESO_ATENDIMENTO
                    ? formData.ID_TIPO_PESO_ATENDIMENTO
                    : 0,
                ID_ORIGEM_LEAD: formData.ID_ORIGEM_LEAD
                    ? formData.ID_ORIGEM_LEAD
                    : undefined,
                ID_TIPO_CANAL_ATENDIMENTO: formData.ID_TIPO_CANAL_ATENDIMENTO
                    ? formData.ID_TIPO_CANAL_ATENDIMENTO
                    : undefined,
            }).then(async () => {
                if (props.caso.ID_OPORTUNIDADE) {
                    await EditarOportunidadeLeadController({
                        DT_FECHAMENTO: formData.DT_FECHAMENTO || undefined,
                        ID_OPORTUNIDADE: props.caso.ID_OPORTUNIDADE,
                        NR_PROBABILIDADE_FECHAMENTO:
                            (formData.NR_PROBABILIDADE_FECHAMENTO ?? 0) / 100 ||
                            undefined,
                        VL_OPORTUNIDADE: formData.VL_OPORTUNIDADE || undefined,
                    }).then(finalizarAtualizacao);
                } else {
                    finalizarAtualizacao();
                }
            });
        });

    const { value: lstTipoPesoAtendimento, loading: lstTipoPesoAtendimentoLoading } = useAsyncEffect(async () => {
        if (id) return ListarTipoPesoAtendimentoAtivosController(id);
    }, [id]);

    return (
        <OrSpinner loading={dadosOportunidadeLoading || lstTipoPesoAtendimentoLoading} spinner="capys">
            <UnForm handleSubmit={handleEditar}>
                <UnForm.Select
                    label="Peso"
                    name="ID_TIPO_PESO_ATENDIMENTO"
                    defaultValue={props.caso?.ID_TIPO_PESO_ATENDIMENTO ?? 0}
                    {...formMethods}
                    registerOptions={{
                        valueAsNumber: true,
                    }}
                    className="form-control mb-2"
                >
                    <option value={0}></option>
                    {lstTipoPesoAtendimento?.map((tpa) => (
                        <option
                            key={tpa.ID_TIPO_PESO_ATENDIMENTO}
                            value={tpa.ID_TIPO_PESO_ATENDIMENTO}
                        >
                            {tpa.DS_TIPO_PESO_ATENDIMENTO}
                        </option>
                    ))}
                </UnForm.Select>

                <label>Origem do Lead</label>
                <UnForm.LazySelect
                    name="ID_ORIGEM_LEAD"
                    controller={VendasListarOrigensLeadController}
                    getDS={(origem) => origem.DS_ORIGEM_LEAD_COMP}
                    getKeyValue={(origem) => origem.ID_ORIGEM_LEAD}
                    defaultValue={props.caso?.ID_ORIGEM_LEAD}
                >
                    <option></option>
                </UnForm.LazySelect>

                <UnForm.LazySelect
                    label="Canal de Atendimento"
                    name="ID_TIPO_CANAL_ATENDIMENTO"
                    controller={listarCanalAtendimento}
                    defaultValue={props.caso?.ID_TIPO_CANAL_ATENDIMENTO}
                    getDS={(c) => c.DS_TIPO_CANAL_ATENDIMENTO}
                    getKeyValue={(c) => c.ID_TIPO_CANAL_ATENDIMENTO}
                    {...formMethods}
                    className="form-control mb-2"
                >
                    <option></option>
                </UnForm.LazySelect>

                <UnForm.Input
                    label="Data de fechamento"
                    name="DT_FECHAMENTO"
                    className="form-control mb-2"
                    type="date"
                    defaultValue={
                        dadosOportunidade?.DT_FECHAMENTO
                            ? dadosOportunidade?.DT_FECHAMENTO?.split("T")[0]
                            : props.caso.DT_EXPECTATIVA_FECHAMENTO?.split(
                                "T"
                            )[0]
                    }
                />

                <UnForm.Input
                    label="Valor da oportunidade"
                    name="VL_OPORTUNIDADE"
                    registerOptions={{
                        setValueAs: (v: string) => {
                            if (v) {
                                return Number(MoneyReaisFieldMask.unMask(v));
                            }
                            return v;
                        },
                    }}
                    className="form-control mb-2"
                    type="text"
                    defaultValue={formatMoneyReais(
                        dadosOportunidade?.VL_OPORTUNIDADE
                            ? dadosOportunidade?.VL_OPORTUNIDADE
                            : props.caso.VL_OPORTUNIDADE || 0
                    )}
                    onChange={geradorMascaraFinanceira("VL_OPORTUNIDADE")}
                />

                <UnForm.Input
                    label="Probabilidade de fechamento (%)"
                    name="NR_PROBABILIDADE_FECHAMENTO"
                    className="form-control mb-2"
                    type="number"
                    min="0"
                    max="100"
                    onChange={(e) => {
                        let value = Number(e.target.value);
                        if (value > 100) value = 100;
                        if (value < 0) value = 0;
                        e.target.value = value.toString();
                    }}
                    defaultValue={
                        dadosOportunidade?.NR_PROBABILIDADE_FECHAMENTO
                            ? (dadosOportunidade?.NR_PROBABILIDADE_FECHAMENTO ??
                                0) * 100
                            : (props.caso.NR_PROBABILIDADE_FECHAMENTO ?? 0) *
                            100 || 0
                    }
                />

                <UnForm.SubmitButton
                    color="primary"
                    icon={faEdit}
                    className="w-100 mt-3"
                    wrapperClassName="w-100"
                    loading={handleEditarLoading}
                    disabled={handleEditarLoading}
                    loadingSize="sm"
                >
                    Salvar
                </UnForm.SubmitButton>
            </UnForm>
        </OrSpinner>
    );
}
